// Populated by: iso-week (done), werkbon-hours (done), werkbon-recurring (done), travel-variance (done), planning (B2), offertes (B4)
export * from './iso-week'
// FO-044-P1 (batch-16) — uniforme, sorteerbare export-bestandsnaam-helper.
export * from './export-filename'
// Spec 41 — best-effort extractie van de contract-startdatum uit PDF-tekst
// (migratie van losse contractdocumenten naar het EmploymentContract-model).
export * from './contract-datum-extractie'
export * from './werkbon-hours'
export * from './werkbon-pauze'
// batch-63 pauze-tweeassig (FO-473) - beslissing per dagregel in de pauze-herrekening.
export * from './werkbon-pauze-herrekening'
// FO-018 (batch-14) — uniforme reistijd-weergave "Xu Ym" (opslag blijft minuten).
export * from './reistijd-format'
// FO-063 (batch-19) — navigatie-deeplinks (Google Maps / Apple Kaarten / Waze)
// + Apple-toestel-detectie voor het keuzemenu van de Navigeer-knop.
export * from './maps'
export * from './werkbon-recurring'
export * from './client-work-schedule-tijden'
export * from './dienst-uitzonderingen'
export * from './shift-roster'
// FO-367 (batch-42) — gedeelde rotatiepatroon-presets + DayCode-parse voor de
// RotatiePatroonEditor (klant-wizard + backoffice-werktijden-tab). Bevat ook
// getDefaultRotations (hierheen verhuisd uit apps/api/src/lib/shift-defaults.ts).
export * from './rotatie-presets'
// FO-348 (batch-40) - dienst-slots: de gedeelde dienstdefinitie van de dekking
// (verwacht == aantal slots, gepland == gevulde slots). Bevat ook
// geldendeDienstenInWeek/verwachteDienstenInWeek, hierheen verhuisd uit
// shift-roster zodat ze uit dezelfde slot-lijst volgen.
export * from './dienst-slots'
// FO-061 (batch-18) - dienst-resolver: rotatierooster + datum -> geldende
// ploegdienst (voor het bijplannen van een losse dag met de juiste dienst).
export * from './ploegdienst-resolver'
// FO-058 (batch-18) — pure onderhoud-controle (verwacht vs gepland + acceptatie).
export * from './onderhoud-controle'
// FO-058 (batch-18) — pure helpers voor de geautomatiseerde placeholder-mails.
export * from './mail-automatisering'
export * from './travel-variance'
export * from './uren-variance'
export * from './planning-actie-status'
export * from './planning-period'
export * from './planning-styles'
export * from './planning-gaps'
export * from './planning-capacity'
// Ronde 4 W1 PF4 — weekdag-selectie met ploegSoort-support (zondagnacht-fix).
export * from './planning-weekdays'
// Planbord scope-selectie — weekdag-toekomst predikaat (NL-tijd, ma-zo).
export * from './planning-scope'
// FO-135 (batch-27) — gedeelde nachtdienst-definitie (eind < start = over
// middernacht) + netto dienstduur (+24u); gedeeld door planbord-display,
// edit-validatie (los + bulk) en de urenberekening.
export * from './planning-dienst'
// FO-425 (batch-58) — klantenportaal-planning: statusmapping (intern -> korte
// klant-statusset) + pure bord-layout-helpers (tijd-naar-positie, groepering,
// uren-opbouw) zodat klant-view en intern bord dezelfde rekenkunde delen.
export * from './klant-planning-status'
export * from './klant-planning-groepering'
export * from './klant-planning-weekoffset'
export * from './planning-bord-layout'
// batch-66 planbord-klantfilter (FO-487) - de klantplanning-weergave van het
// interne planbord: telling per dag/week, rij-splitsing en de schakelaar-stand.
export * from './planbord-klantweergave'
// FO-426 P7 (batch-58) — klant-akkoord-label op basis van de akkoord-REGISTRATIE
// i.p.v. de interne `GOEDGEKEURD_KLANT`-status.
export * from './klant-akkoord-label'
// FO-426 P3 (batch-58) — DE regel voor "welk werkschema voedt de verwachte
// diensten in de klant-jaarplanning" (gedeeld door de API en het beheer).
export * from './klant-werkschema-actief'
export * from './quote-calculations'
// Features 19-22 (spec 20 §2.2.2 + §2.4.1) — kostprijs & marge.
export * from './employee-cost'
// Batch-4 calc — medewerker-kostprijs-autofill + calculatie-engine + overhead-tool.
export * from './employee-cost-autofill'
export * from './calculation-engine'
// Batch-9 #71 — kostprijs ↔ opbrengst vergelijk (klant/rooster, per uur/week/maand).
export * from './kostprijs-vergelijk'
export * from './overhead-calc'
export * from './quote-cost'
// Spec 20 §2.5 + §2.6 — management-dashboard berekeningen (marge per pakket,
// bezettingsgraad, omzet/kosten/winst, capaciteit per medewerker).
export * from './management-calc'
export * from './invoice-calculations'
export * from './overuren-staffel'
export * from './tariff-resolution'
export * from './leave-calculations'
// Parttime-/vast weekrooster (spec parttime-rooster-verlof-verzuim).
export * from './contract-rooster'
// FO-388 (batch-46) — ketenregeling-teller + aanzegplicht-predicaat (pure).
export * from './ketenregeling'
// Feestdag-naar-rato compensatie (parttimers, art. 7:648 BW).
export * from './feestdag-compensatie'
// Vervalstatus van verlof-emmers t.o.v. een peildatum (saldo-weergave).
export * from './verval-status'
// Vervaldatum-defaults per emmertype (engine-pariteit; import + backfill).
export * from './verlof-vervaldatum'
export * from './worked-hours-split'
export * from './toeslag-resolver'
export * from './toeslag-componenten'
export * from './verlof-profiel'
export * from './sick-leave-calculations'
export * from './sick-leave-v1-migration'
export * from './uren-calculations'
export * from './declaraties-calculations'
export * from './werkbon-create-helpers'
export * from './distance-cache-utils'
export * from './mutatie-validation'
// batch-46 adres-reis (FO-390) — verhuisdatum-bereik (gedeeld portal/API/backoffice).
export * from './verhuisdatum'
export * from './payroll-calculations'
// batch-69 tvt-saldi (FO-513 §C7) — één bron voor de TVT-factor per week/dag + dubbel-indicator.
export * from './tvt-factor'
// Batch-9-vervolg V5 (PO #10) — generiek periode-filter voor payroll/uren.
export * from './payroll-periode'
// FO-115 (batch-22) — portal-periode-keuze (deze week/maand/vorige maand/eigen).
export * from './portal-uren-periode'
// FO-491 (batch-66) — de eigen-uren-periode knippen op de kalenderperiode
// (knipOpPeriode + de dag-toerekening van de week-splitsing).
export * from './uren-periode-knip'
// FO-012 (batch-14) — periode-saldering van 100%-uren tegen de maand-contracturen
// (verlaagde norm + reisuren-aanvulling). De kritische verloning-rekenkern.
export * from './payroll-periode-saldering'
// FO-318 (batch-35) — de verloning-telregels als pure engine
// (`berekenPeriodeAfrekening`): tekort→reisaanvulling→contracturen, overschot→
// reservering, DAG-staffel 25/50/100, reisuren-routering, ploeg/za/zo-toeslag.
// VERVANGT de FO-305 overuren-staffel-indeling als verloning-regel. Geld-pad.
export * from './verloning-telregels'
// FO-318 (batch-35) §3.1 — ploegtoeslag-bron-hiërarchie (casus Ojah): klantrooster
// autoritatief → werkbon-dienstType fallback → geen; conflict-signaal voor het scherm.
export * from './ploegtoeslag-bron'
// FO-318 (batch-35) §3.3 — de expliciete twee-filterregel voor interne/cursus-
// werkbonnen: tellen WEL in verloning/weekstaat, NIET in facturatie.
export * from './interne-bon-filter'
// FO-319 (batch-35) — extractie reservering-categorieën → NMBRS-looncode-uren.
// DE pariteit-bron: overzicht + export lezen beide hierlangs.
export * from './nmbrs-looncode-extract'
// FO-305 P7 (batch-33) — contracturen per maand, pro-rata (kalenderdagen) over
// de contractmutatie-historie + dienstverband-clamp. Eén bron voor alle vier de
// afnemers (verloningsperiode, contracturen-check, min-uren, reservering).
export * from './contract-uren-maand'
export * from './payroll-emmer-split'
export * from './verzuim-dag'
export * from './verzuim-doorbetaling'
export * from './voertuig-utils'
// Spec 40 - bijtelling-calculator (auto als bron: cataloguswaarde + DET +
// brandstof + onderhoudbare tarieventabel -> staffel/bedrag/effectief %).
export * from './bijtelling'
// FO-361 (batch-41) - netto-bijtelling-indicatie (IB-schijven + heffingskortingen,
// parametergedreven per belastingjaar; berekenhet-methodiek).
export * from './bijtelling-netto'
export * from './communicatie'
export * from './rapportage-aggregations'
// Batch-8 rapportage — reistijd-afwijking-statistiek (mediaan + week-detectie).
export * from './reistijd-afwijking'
export * from './onboarding-helpers'
export * from './onboarding-verlopen'
export * from './offboarding-helpers'
export * from './intercompany-calculations'
export * from './intercompany-blockades'
export * from './intercompany-ontbrekende-data'
export * from './intercompany-vooruitblik'
// Period-engine helpers (week/maand/kwartaal/eenmalig) — pure NL-tijd tijdvakken.
export * from './intercompany-periode'
export * from './csv-utils'
export * from './inkoop-calculations'
// FO-147 (batch-28) — largest-remainder-verdeling van een inkoopfactuurregel
// over meerdere medewerkers (sluitend op integer centen; gedeeld API + UI).
export * from './kosten-verdeling'
// FO-078 (batch-20) — pure BTW-aggregatie per tarief/BV (verkoop + inkoop, saldo).
export * from './btw-aggregatie'
// FO-124 (batch-24) — aangifteperiodes per BV-frequentie (maand/kwartaal/jaar).
export * from './btw-aangifteperiode'
export * from './inkoop-besteltraject'
export * from './offerteaanvraag-mail'
// FO-392 (batch-46) — pure rekenkern inkoopbudget-tellers (obligo/gerealiseerd).
export * from './inkoop-budget'
// FO-393 (batch-46) — tekstnormalisatie (verhuisd uit inkoop-toewijzing-suggest)
// + pure 3-way-match-engine.
export * from './inkoop-tekst'
export * from './inkoop-match'
// batch-66 inkoop-afwijkingen (FO-490) - pure regels van het afwijkingen-register
// op inkoopfacturen: statusmachine, bedragberekening, stand + betaalblokkade,
// AFW-referentie, creditnota-matcher, match-oordeel -> afwijking, mailsjabloon
// en regel-herankering. Gedeeld door API, formulier en tests.
export * from './inkoop-afwijkingen'
// batch-66 inkoop-afwijkingen (FO-497) — pure regels van de boeteflow.
export * from './boetes'
// batch-66 inkoop-afwijkingen (FO-497) — de verdeling van inhoudingsregels over boetes (puur).
export * from './boete-bewaking'
export * from './targeting-distance'
export * from './workflow-engine'
export * from './workflows/verlof-workflow'
export * from './workflows/declaratie-workflow'
export * from './workflows/weekstaat-workflow'
export * from './workflows/verzuim-workflow'
export * from './workflows/mutatie-workflow'
export * from './workflows/onboarding-workflow'
// skillmatrix-parser bewust NIET in de barrel: trekt exceljs (→ unzipper →
// fstream → require('rimraf')) mee in elke Next.js server-bundle die iets uit
// @streep/utils importeert. rimraf staat op Next's server-external-packages-
// lijst en is onder pnpm niet resolvable vanuit de app → standalone mist 'm →
// runtime 500 "Cannot find module 'rimraf'" op tig portal/backoffice-pagina's.
// Import via subpath: '@streep/utils/skillmatrix-parser' (alleen API).
export * from './formulieren-validation'
export * from './kwaliteit-stats'
export * from './projecten-calculations'
export * from './dashboard-utils'
// PR-4 Ronde 3 — consignatie EXCLUDE-filters (spec 02 §5 + §7 + §13 R4).
export * from './consignatie'
// PR-E3 (spec financiele-afscherming §9.2) — gedeelde rechtenmatrix.
export * from './module-permissions'
// Verjaardag-keuze — pure helpers voor de januari-keuze-campagne.
export * from './verjaardag-keuze'
// Track-H quickwins-p2 — Entity.activeFrom gate voor dropdowns/selectors.
export * from './entity-activation'
// Spec C §7.1 — generator voor bedrijfs-emailadressen bij onboarding-SYSTEMEN.
export * from './email-generator'
// `encryption.ts` is server-only (imports node:crypto). Niet via barrel
// re-exporteren — gebruik direct `import { encryptField } from '@streep/utils/encryption'`
// in API/server-componenten.
// Skillmatrix v2 — pure business-logica (aggregatie, borging, matching).
// NB: kosten-berekening blijft in apps/api/src/lib/skill-kosten.ts (1-10 schaal).
export * from './skill-aggregation'
export * from './skill-borging'
export * from './skill-matching'
// FO-306 (batch-33) — klant-3-puntsniveau (Basis/Goed/Expert) → interne skill-schaal.
export * from './klant-niveau-mapping'
// Beschikbaarheid-weekdagen (ma–zo) + default-waarden — gedeeld tussen create- en detail-forms.
export * from './availability-weekdays'
export * from './html-strip'
export * from './recurrence'
// Dag-precisie datum- + duur-helpers (gedeeld; o.a. operationele takenmodule,
// werkbonnen, opleidingen). Bestandsnaam is historisch (ex-DagTaak).
export * from './dagtaken-datum'
// Operationele takenmodule (spec 34) — pure escalatie-ladder.
export * from './taak-escalatie'
// Operationele takenmodule (spec 34 § 3) — open-lijst-sortering.
export * from './taak-sortering'
// Operationele takenmodule (spec 34 § 7) — deterministische fuzzy-match (Dice).
export * from './fuzzy-match'
// DST-correcte Amsterdam wall-clock ↔ UTC helpers (kalender, planning, uren).
export * from './amsterdam-tijd'
// Loonstroken: geplande-vrijgave-moment (gepland klaarzetten + auto-planning).
export * from './loonstrook-vrijgave-moment'
// batch-66 (FO-492) — wanneer een loonstrook als goedgekeurd geldt (afgeleid, geen status).
export * from './loonstrook-goedkeuring'
// Tijdzone-vaste datum/tijd display-formatters (Europe/Amsterdam) — voorkomt
// SSR/hydration-mismatch in 'use client'-componenten (React #425/#422).
export * from './datum-weergave'
// Dag-normalisatie voor mutatie-ingangsdatums (contract-/salarismutaties):
// elke effectiveFrom wordt UTC-middernacht van de bedoelde NL-kalenderdag.
export * from './mutatie-datum'
// FO-097 / FO-098 (batch-21) — periode-keuze (maand/aantal-maanden) → van/tot.
export * from './employee-kosten-periode'
// Uitrusting-bestelmodule — pure credit-saldo + kwartaal-afleiding (NL-tijd).
export * from './uitrusting-credits'
// FO-059 — order-groepering per leverancier voor de uitrusting-bestelmail.
export * from './uitrusting-bestelmail'
export * from './telefoon-format'
// Maten-normalisatie (batch-3 B) - halve schoenmaten + komma/punt-canonicalisatie.
export * from './maten'
export * from './planning-sort'
// Dienstverband + leeftijd — pure datum-helpers voor HR/jubileum (NL-tijd).
export * from './dienstverband'
// Spec 33 fase 1 — week-netting: overuren en min-uren per week.
export * from './week-overwerk'
// Spec 33 fase 2 — lock-timing: bepaalt of het auto-afsluitmoment van een weekstaat verstreken is.
export * from './weekstaat-lock-timing'
// Uitrusting - pure maat-normalisatie + match (portal-catalogus + API-toekenning).
export * from './uitrusting-maat'
// Uitrusting - leidt aantal + artikelnaam af uit de vrije `opmerkingen`-tekst
// (bedrijfsmiddelen-tab toonde anders in elke rij alleen het type "KLEDING").
export * from './uitrusting-omschrijving'
// Spec 2026-08-25 — voorraadkoppeling per maat-variant: maat/categorie/naam-helpers
// gedeeld door koppel-endpoint, aanmaak-service en backfill.
export * from './uitrusting-variant-voorraad'
// Spec 2026-08-25 — eenmalige backfill variant-voorraadkoppeling: pure besluit-
// en SQL-opbouwlogica (bepaalBesluiten/bouwSql/rapport), gedeeld met het dunne
// CLI-script in packages/db zodat de tests in de deploy-gate meedraaien.
export * from './uitrusting-variant-voorraad-backfill'
// batch-57 (FO-419) - brede inhaal-migratie catalogus <-> voorraad: alle vier de
// categorieen (incl. gereedschap), beide koppel-niveaus (maat-variant en artikel)
// en een SKU/alias-ronde vóór de naam-ronde. Hergebruikt de matcher hierboven.
export * from './catalogus-voorraad-inhaal'
// Navigatie - terug-fallback per route-patroon (404-vangnet voor de gedeelde
// BackButton op routes waarvan de parent geen pagina heeft); ook gebruikt door
// de drift-guard in de api-suite.
export * from './terugknop-fallback'
// Navigatie - `?terug=`-herkomst op detailroutes met meerdere instappunten
// (uniek-item-detail): validator voor het pad + label en de link-bouwer.
export * from './terugkeer-url'
// Batch-6 verlof — ouderschapsverlof (recht per kind) + seniorendagen (staffel)
// + structureel weekpatroon ("elke woensdagmiddag") voor de verlofmodule.
export * from './ouderschapsverlof'
export * from './seniorendagen'
export * from './aow'
export * from './verlof-structureel-patroon'
// Batch-15 (FO-021 + FO-025) — gedeelde "is verlof actief?"-regel + verlof-tijd-
// formatter voor alle planning-weergaves (planbord/portal/capaciteit/inboxen).
export * from './verlof-weergave'
// batch-40 status (FO-340) — de twee lagen dienstverband/werkstatus: gedeelde
// sets, predicaten en actieklassen. De Prisma-where-builders die hierop leunen
// staan in apps/api/src/lib/medewerker-selectie.ts.
export * from './medewerker-selectie'
// Batch-6 hrm — HR-trend-buckets (dag/ISO-week/maand, NL-tijd) + k-anonimiteit.
export * from './hr-trends'
// batch-39 gesprekken (FO-332) — deadline-vorm-resolutie voor actiepunten.
export * from './gespreksverslag-deadline'
// batch-47 gespreksverslagen (spec 90) — DE resolver: events -> hoofdstatus +
// actiestatus + statusbalk. Enige afleiding, geen tweede implementatie.
export * from './gespreksverslag-status'
// FO-349 (batch-40) — factuurdatum: NL-dag-normalisatie, vervaldatum-afleiding
// en de waarschuwingsteksten. Gedeeld door de api en de backoffice-modal.
export * from './factuur-datum'
// Batch-6 cert — afgeleide certificaat-status per (medewerker × type), NL-dag.
export * from './certificaat-status'
// FO-003 (batch-12) — onboarding-startworkflow: relatieve deadline + status-classificatie.
export * from './onboarding-startworkflow'
// batch-71 verplichte-certificaten (FO-541) — groep-status, de stand per eis en de signalen.
export * from './verplichte-certificaten'

// FO-008 (batch-13) — besloten afspraak: de gedeelde server-side toegangsregel
// (mayViewBeslotenContent / mayManageBesloten) + het neutrale "bezet"-blok-label.
export * from './besloten-toegang'

// Batch-7 A3 — RFC 5545 ICS-builder (gedeeld door kalender-feed +
// acquisitie-/recruitment-kalenders).
export * from './ics'
export * from './acquisitie-checkin'

// Batch-14 facturen (FO-017) — SEPA Credit Transfer (pain.001.001.03) voor
// inkoop-betaallijsten: IBAN-mod-97, bedrag-formattering, creditnota-verrekening
// (netto per crediteur), XML-builder. Pure/DB-vrij, dep-vrij.
export * from './sepa'

// FO-040 (batch-16) — detectie van dubbele bestuurders (overlappende actieve
// voertuig-toewijzingen, beide richtingen, excl. tijdelijk-vervangt). Pure/DB-vrij.
export * from './voertuig-toewijzing-overlap'

// FO-151 (batch-30) — vaklocatie (stelling/plank/vak) binnen een magazijn:
// format ("3-1-3"), parse (sneltoets-invoer) en looproute-sortering. Pure/DB-vrij;
// gedeeld door API, backoffice-UI en de QR-/tellijst-PDF-renderer.
export * from './vaklocatie'

// FO-153 (batch-32) — module-sectie-tabs: per-gebruiker volgorde (merge-regels)
// + active-state (incl. querystring-tabs). Pure/DB-vrij; gedeeld door de
// server-side resolver, de API-PUT en de client-side drag-interactie.
export * from './tab-volgorde'
export * from './module-tab-active'

// FO-310 (batch-34) — compleetheid van een gereedschapsdrager (kar/koffer):
// score-berekening + status-classificatie. Pure/DB-vrij; gedeeld door de API
// (controle-score + drager-cache), de overzicht-badges en de trend-collector.
export * from './compleetheid'

// batch-48 (spec 97, bestelmail-dedup) — leesbaar kenmerk van een leveranciers-
// bestelling (BEST-A1B2C3) + de blokkerende kopie-waarschuwingstekst. Pure;
// gedeeld door de API (waarschuwing + DTO's) en de backoffice-UI.
export * from './bestel-kenmerk'

// Batch-8 skills — skill-niveautekst-parser bewust NIET in de barrel (zelfde reden
// als skillmatrix-parser hierboven: exceljs → unzipper → fstream → require('rimraf')
// belandt anders in elke Next.js server-bundle die iets uit @streep/utils importeert
// → runtime 500 "Cannot find module 'rimraf'" op portal/backoffice-pagina's).
// Import via subpath: '@streep/utils/skill-niveautekst-parser' (alleen scripts/API).

// FO-307-A1 (batch-33) - pure logica voor de offline-mutatie-wachtrij van de portal.
export * from './offline-sync'
export * from './voorraad-duplicaten'
// FO-391 (batch-46) - pure rekenkern voor de jaarlijkse tarief-indexatie
// (Decimal-exact via BigInt, afronding half-up alleen op het eindbedrag).
export * from './indexatie'

// FO-395 (batch-46 relaties-kvk) - pure diff + deterministische scan-spreiding.
export * from './kvk-mutatie-diff'

// FO-399 (batch-49 acquisitie-threads) - pure draad-opbouw voor contactmomenten
// (acquisitie én CRM delen hetzelfde `vervolgOpId`-veld).
export * from './contactmoment-draad'

// FO-401 (batch-49) - rechtsvorm-veilige naamsamenstelling voor gegenereerde
// documenten (voorkomt "A. Jansen B.V. B.V."); gedeeld door de placeholder-
// autofill en de sjabloon-lint.
export * from './rechtsvorm'

// FO-400 (batch-49) - pure prefill voor de projectovereenkomst-wizard: relatie +
// STREEP-entiteit -> basisgegevens + merge-waarden. Verzint nooit een waarde.
export * from './projectovereenkomst-prefill'

// batch-49 in-te-plannen (FO-398) - pure regels achter het vak "In te plannen":
// urgentie (< 48 uur), verlopen/te-lang-open, sortering en de herkomst-badge.
// Gedeeld door de band-DTO, de escalatie-cron, de dekkingsmail en de UI.
export * from './in-te-plannen'

// batch-50 reistijd-geocode (FO-403) - geocode-querybouw ([straat + nr] óf [nr])
// + kwaliteitsgate op partial_match/types + landmidden-detectie. Gedeeld door de
// API (GoogleApiService) en de sanerings-/scan-scripts in packages/db.
export * from './geocode-kwaliteit'

// batch-53 acquisitie-vervolg (FO-407) - urgentie-band (verlopen/vandaag/later)
// in NL-tijd + de vier snelkeuze-datums achter de chips. Gedeeld door de
// overzicht-query, de dagcron en het notitie-invoerveld.
export * from './acquisitie-vervolg'

// FO-410 (batch-54) - DE gedeelde adres-samenstellingsmapper voor documentgeneratie
// (straat zonder nummer, huisnummer los, adres = straat + nummer, plaats zonder
// postcode, postcode + plaats). Gedeeld door de klant-/entiteit-autofill en de
// projectovereenkomst-prefill; nooit een samengestelde waarde in een enkelvoudig veld.
export * from './adres-samenstelling'

// batch-54 klant-akkoord-mail (FO-412) - pure helpers rond de klant-reply op de
// goedkeurings-mail: referentiecode bouwen/parsen, de nieuwe reply-tekst uit de
// mail pellen (quotes/disclaimers eraf), out-of-office/bounce-herkenning,
// message-id-normalisatie en het overzicht-versietoken.
export * from './klant-akkoord-mail'

// batch-56 loonstroken (FO-422) - pure run-helpers: run-label voor de UI, de
// run-aanduiding van de strook lezen en het eerstvolgende vrije run-nummer.
// Gedeeld door de API (import/upload/plaatsing), de backoffice en de portal.
export * from './loonstrook-run'
// batch-61 loonstrook-dedupe (FO-456) - de INHOUD-vingerafdruk van een strook
// (BV/medewerker + periode + run + bruto/netto, Decimal-exact genormaliseerd,
// sha256) en de mail-niveau bijlage-set-hash. Gedeeld door persist/mail-
// processor/koppel-pad (API), de backfill/opschoonrun (packages/db) en tests.
// `sha256.ts` is de dependency-vrije, synchrone hash eronder (browser-veilig).
export * from './loonstrook-vingerafdruk'
export { sha256Hex } from './sha256'
// batch-56 klantenportaal (FO-413 D5) - pure ervaringscategorie-afleiding uit
// de uren bij DEZE klant, met per-klant instelbare grenzen. Gedeeld door de
// dagelijkse cron (cache vullen), de klant-DTO en het backoffice-instelscherm.
export * from './klant-ervaring'
// FO-438 B4 - de betaalstatus die de klant leest: alleen een echte betaling
// DOOR de klant telt; factoring-uitbetaling aan STREEP nooit.
export * from './klant-factuur-betaalstatus'

// batch-58 uitdienst-verlof (FO-424) - pure regels rond de einddatum van het
// dienstverband: ligt een verlofaanvraag voor/over/na de einddatum, welke actie
// hoort daarbij (intrekken/inkorten/afwijzen/werklijst) en de bijbehorende
// kopij (notitie, reden, samenvatting, guard-uitleg). Gedeeld door de
// uitdienst-transactie, de bevestigingsstap in de dialoog en de cockpit.
export * from './uitdienst-verlof'
// batch-58 profiel-match (FO-429) - DE pure match-berekening tussen het door de
// klant gewenste monteur-profiel en een monteur (vaardigheden + certificaten,
// incl. geldigheid), plus de format-/sorteerhelpers. Gedeeld door de beheer-tab,
// het planbord-toewijzingspad, de pickers en de audit-schrijver.
export * from './profiel-match'
// batch-58 klant-portaal-beheer (FO-428) - DE pure resolver voor "ziet de klant
// dit stuk?": flow-stand (verstuurd/tekenverzoek/getekend) gecombineerd met de
// drie-standige beheerder-override, plus de D6-documentvariant. Gedeeld door de
// portaal-DTO en de gebundelde beheer-lijst, zodat scherm en klant nooit
// uiteenlopen.
export * from './klantportaal-vrijgave'

// batch-59 voertuig-afspraken (FO-435) - DE pure actie-status per voertuig:
// APK / verzekering / intern-open terugroepactie x wel/geen afspraak ->
// "Actie vereist" / "Gepland {datum}" / "Uitgevoerd". Server-side gerekend en
// gedeeld door de lijst, de KPI-teller en het voertuig-detail.
export * from './voertuig-actie-status'
// batch-59 voertuig-afspraken (FO-435 stap 1-2) - pure parser voor de door een
// garage aangeleverde onderhoudshistorie (kenteken/datum/omschrijving/bedrag/km),
// inclusief NL- en EN-notatie voor datums en bedragen.
export * from './voertuig-historie-import'
// batch-59 loonstrook-controles (FO-433) - de pure controle-regels: strook-
// voertuig tegen de berijder-historie van de periode (geen valse afwijking bij
// een voertuigwissel), strook-bijtelling tegen de registratie, en de matcher die
// een inhoudingsregel aan een openstaande boete koppelt.
export * from './loonstrook-controle'
// batch-59 interne-facturen (FO-432) - pure kern van de patroonherkenning voor
// interne (intercompany) inkoopfacturen: periode-sleutels (maand / 4 weken /
// kwartaal, in Europe/Amsterdam), de omschrijvingssleutel en de reeks-detectie
// op hele centen. Gedeeld door de dagelijkse analyse-cron, de herhaal-regel-
// generator en de periode-beoordeling in de API-DTO's.
export * from './interne-facturen-patroon'
// batch-59 onboarding-review (FO-437) - DE pure regel voor "welke klant-sectie
// van een relatie-onboarding wacht nog op beoordeling". Gedeeld door de
// voltooi-gate, de Goedkeuringen-inbox (count == lijst), het Postvak-blok en de
// inbox-reconciliatie, zodat badge, lijst en sluitmoment nooit uiteenlopen.
export * from './relatie-onboarding-review'

// batch-60 vaste-monteur (FO-440) - DE pure bezettingsstatus-resolver: dagregel
// + vaste monteur + afwezigheidsbronnen -> VAST / VERVANGEN / NOG_TE_PLANNEN /
// VASTE_MONTEUR_AFWEZIG_MAAR_GEPLAND (+ GEPLAND/ONBEMAND voor losse inzet), de
// slot-koppeling voor 2-mans-diensten, de klant-lezing ("vervangen door" /
// "vervanging wordt ingepland") en de afleiding van de vaste monteur uit de
// planhistorie. Gedeeld door de monitor, de klant-DTO's en de escalatie-cron.
export * from './bezettingsstatus'
// batch-60 vaste-monteur / FO-439 K2 - DE gedeelde klant-tijdformatter
// (Europe/Amsterdam, locale van de klant); de drift-guard in de api dwingt af
// dat elke klant-facing tijd/datum-render hierdoorheen gaat.
export * from './klant-tijd'
// batch-60 klantportaal-zichtbaar-verzoeken (FO-439b K4) - de pure statusregels
// van de uniforme klantverzoek-opvolging: één statusset (die van
// ClientPortalRequestStatus) voor alle klant-geïnitieerde acties, de vertaling
// van/naar de D7/D8-statusset (GEREGELD == AFGEROND) en de escalatie-regel
// "onbeantwoord > X uur". Gedeeld door API (opvolging + cron), backoffice en
// klant-app.
export * from './klantverzoek-status'
// batch-60 facturen-verwijderen (FO-443) - DE pure regel "mag deze factuur
// verwijderd worden": origin-bewust (eigen concept, definitief-nooit-verzonden,
// Finqle-proforma/-import/-spiegel), met blokkade (crediteren / corrigeer bij
// Finqle), reden-verplicht-vlag en gevolgen. Gedeeld door de API-route, de
// lijst-/detail-DTO en de bulk-actie.
export * from './factuur-verwijderbaarheid'
// batch-61 portal-collega (FO-446) - DE pure regels achter "sta ik alleen of
// met een collega van STREEP": tijdoverlap (drempel), aflossing, tijd-hints
// ("Rico tot 15:00"), de kaart-regel en de week-badge (badges == kaarten per
// constructie). Gedeeld door de API-afleiding, de wijzigingsmelding en de portal.
export * from './collega-op-dienst'

// batch-61 werkbon-gefactureerd (FO-449) - DE pure resolver van het facturatie-
// spoor op een werkbon (`facturatieStatusVan`): eigen factuur wint, daarna de
// persistente markering (Finqle-verzending / Finqle-API / handmatig), daarna de
// legacy-proforma, daarna niet-facturabel / nog te factureren. Gedeeld door de
// backoffice-lijst en -detail, KPI's/rapportages en de klant-DTO.
export * from './werkbon-facturatie'
// batch-63 integratie (review I2) - de oude nummerloze Finqle-spiegelrij (pure regel).
export * from './oude-finqle-rij'

// batch-61 taken-filters-status (FO-447) - DE pure overgangs-matrix van de
// operationele takenmodule (toegestane overgangen, reden-/planning-verplichting,
// snelle acties per rol, open-/actieve-/afgesloten-sets) + de startscherm-
// sortering/groepering van "Mijn taken". Gedeeld door API, backoffice en portal.
export * from './taak-status'

// batch-61 uitrusting-credits-maten (FO-445) - pure regels van de Van Ysselt-
// saldo-sync: NL-dagsleutel/dagbundel-moment, credits per leverwijze-deel,
// idempotency-keys, eerste werkdag van de maand en de deling-status.
export * from './vanysselt-saldo'
// batch-61 uitrusting-credits-maten (FO-455) - maten-samenvatting voor de
// leesweergave en de informatieve regel op bestel-/uitgifteschermen.
export * from './maten-samenvatting'

// batch-62 uitrusting-inkoop (FO-466 + FO-467) - pure regels voor pakbon/factuur
// -> uitrusting (dubbel-controle, artikel-match via SKU of naam+maat, voorstel-
// actie) en voor verwerken zonder bestelling (telverschil, afwikkeling,
// opschoonlijst). Gedeeld door API en tests.
export * from './uitrusting-inkoop'
// batch-62 garage-voertuig (FO-462 + FO-465) - pure regels: kostencategorie-
// voorstel per garagefactuurregel (onderhoud vs schade), schadedossier-
// kandidaat, werkdatum-afwijking, km-plausibiliteit en de reminder "volgende
// actie" (datum EN km-drempel, wat het eerst komt).
export * from './garage-voertuig'
// batch-62 kostprijs-werkelijk (FO-460 + FO-461) - pure regels van de werkelijke
// kostprijs: periodes, kostensoort, totaalcontrole, dedupe, loonmapping (versie-
// vast), loonkost-aggregatie, bijtelling pro rata, verbruik en de samenstelling.
export * from './kostprijs-werkelijk'
// batch-62 telefoonabonnementen (FO-463) - DE matchsleutel van het telefonie-
// register (telefoonnummer -> E.164, ICCID) + de pure registerregels: afgeleide
// register-status, contract-/opzegsignalen, stilzwijgende verlenging, maandlasten
// per BV ("onvolledig"), totaalcontrole en afwijking van providerfacturen, en de
// import-parsers. Gedeeld door API (register, cron, factuur, import) en backoffice.
export * from './telefoonnummer'
export * from './telefonie'
// batch-62 briefpapier (FO-459) - pure briefpapier-resolver: voorgevulde keuze
// (cascade), toepassing met zichtbare terugval + waarschuwingen, en het
// factuur-briefpapier met de harde Finqle-regel (FO-011). Gedeeld door API en kiezer.
export * from './briefpapier-resolver'
// batch-62 taken-ux (FO-464) - pure regels rond gereedmelden: het ongedaan-
// venster (24 uur) en de status om naar terug te keren, de open-checklist-
// vraag, het vervolgbericht, de deadline-kleur en de standaard-deadline uit een
// sjabloon. Gedeeld door API, backoffice en portal.
export * from './taak-gereedmelden'
// batch-62 klant-vaste-inzet (FO-458) - DE pure kring-beslissing: vaste monteur
// (FO-440, ook voorlopig) + lopend ingepland + D5-ervaring >= Regelmatig, minus
// uitsluiting, plus toevoeging, strengste-wint op zichtbaarheid; plus de rol op
// een afwezigheidsmelding en het samenvouwen van afwezige dagen tot perioden.
// Gedeeld door afwezigheid, jaarplanning, weekplanning, monteurspagina en beheer.
export * from './vaste-inzet-kring'
// batch-63 certificaat-mailbox (FO-469) - pure regels van de certificaat-mailbox:
// medewerker-match (fuzzy maar alleen eenduidig, nooit een naamgenoot), type-match
// (alleen exact/synoniem, nooit verzameltypes), opleider-match, datums (vervaldatum
// of afgeleid uit een geldigheidsduur), vindMogelijkDubbelCertificaat, de
// automatisch-of-review-beslissing, bundelsplitsing, certificaat-links en de
// afzenderterugkoppeling. Gedeeld door API (processor + review) en backoffice.
export * from './certificaat-mailbox'
// batch-63 cursusplanning (FO-468) - pure regels achter de cursusaanvraag aan de
// opleider: referentie in het onderwerp, locatievoorstel op afstand (laagste
// gemiddelde, spreiding, splitsen), cursusdagen, bewaking (werkdagen),
// bevestiging-vergelijking en de onder-voorbehoud-markering. Gedeeld door API en wizard.
export * from './cursus-aanvraag'
// batch-63 integrator - e-maildomein + publieke mailproviders, gedeeld door
// certificaat-mailbox en cursusaanvraag (was dubbel geexporteerd).
export * from './email-domein'
// batch-65 inkoop-kosten (FO-482) - kostensoort herkennen aan de omschrijving op de
// zoekwoorden uit de stamtabel (pure functie).
export * from './kostensoort-herkenning'
// batch-65 inkoop-kosten (FO-483) - toerekenen en doorbelasten (rekenwerk, status, voorstellen).
export * from './inkoop-doorbelasting'
// batch-65 inkoop-kosten (FO-483) - kosten- en marge-inzicht (relatie, werkbon, project).
export * from './inkoop-kosten-inzicht'
// batch-65 voorraad-besteladvies (FO-481) - pure regels van het gebundelde
// besteladvies: adviesaantal (hergebruikt berekenBesteladvies + berekenAanvulAdvies,
// afgerond op de besteleenheid), minimumniveau-voorstel (stelMinimumVoor),
// stilteperiode, het run-venster (werkdagen, instelbaar tijdstip), te-laat en
// het bestelbericht. Gedeeld door API (cron + routes) en backoffice.
export * from './besteladvies'
// batch-69 magazijn-cijfers (FO-521 §A) - voorraadwaarde: waarderingsprijs
// (artikel- of laatste orderprijs), exacte sommen, percentage en boekwaarde.
export * from './voorraad-waarde'
// batch-69 magazijn-cijfers (FO-520) — telsessie: verschil, vier ogen, looproute, nummering.
export * from './voorraad-telling'
// batch-65 finqle-verzamelbon (FO-484) - pure regels van de verzamelbon: nummer
// (VB-jaar-volgnr, -deel, -revisie), herkennen in vrije tekst (Finqle-matcher),
// totalen in hele centen met btw over het documenttotaal, eenheid per regel,
// periode + ISO-week, bundelvoorstel per klant x BV x week/maand, revisie-regels.
export * from './verzamelbon'
// batch-65 uitrusting-flow (FO-479) - de pure diff tussen een afgekeurde
// uitrustingbestelling en haar herindiening (regels per variant, maatwissel per
// artikel, bezorgkeuze en vrij verzoek). Gedeeld door API (DTO) en tests.
export * from './uitrusting-herindiening'
// batch-65 uitrusting-flow (FO-480) - wanneer kan een medewerker zijn uitrusting
// ophalen: het voorstel en de alternatieven op planning- en verlofinvoer
// (kantoordag, vrije dag, voor of na een dienst; verlof/ziek en feestdagen
// overgeslagen), plus de datum- en tekst-hulpjes. Gedeeld door API en tests.
export * from './uitrusting-levering'
// batch-65 apk-rapport (FO-478) - pure regels achter het APK-rapport: de §6-
// waarschuwingen (bereik, dubbel binnen 30 dagen, uitgefaseerd, kenteken),
// het vervaldatum-voorstel en de RDW-afstemming. Gedeeld door API en formulier.
export * from './apk-rapport'
// batch-65 factuur-richting (FO-486) - de gedeelde eigen-BV-herkenning (KvK,
// naam, alias en nu ook rekeningnummer; verhuisd uit de api zodat er één bron
// van match-logica is) en de pure richting-beoordeling van een binnengekomen
// factuur (verkoop / inkoop / intern), Finqle-herkenning en kostensoortvoorstel.
export * from './eigen-bv-herkenning'
export * from './factuur-richting'
// batch-66 voertuigcontrole (FO-489) - de eerstvolgende run van een
// CronSchedule-rij (frequentie + tijd in Europe/Amsterdam), puur en DST-veilig.
export * from './cron-volgende-run'
// batch-66 voertuigcontrole (FO-489) - de herstelactie bij een loonstrook waar de
// voertuig-cascade geen voertuig vond (koppelen, voertuig toevoegen of een
// leer-mapping), puur.
export * from './loonstrook-voertuig-herstel'
// batch-66 interne-geldstroom (FO-494) - de pure kern van het koppelen aan de
// interne geldstroom: tegenpartij-, spiegel-, engine- en origineel-voorstel, de
// statusbeoordeling (een verschil is nooit stil) en het automatisch-koppel-oordeel.
export * from './interne-geldstroom'
// batch-66 verkoop-extractie (FO-493) - de pure kern van de factuurextractie met
// opmaakprofielen: kerning-bestendige tekst-hulpjes, de Finqle-tekstlezer,
// profielherkenning, naverwerking met zekerheid per veld en de IBAN-blokkade,
// de leerlus (correctie -> patroon -> voorstel) en de regel-dagregel-koppeling.
export * from './factuur-extractie'
// batch-66 contract-mijlpalen (FO-496) - pure planner en regels van de mijlpaal-
// workflow rond het arbeidscontract: proeftijd-afleiding, berekenMijlpalen
// (ankers, offsets, werkdagen, Europe/Amsterdam), de herberekening bij een
// datumwijziging, de dagelijkse stap en de afrond-controle. Gedeeld door de API
// (motor + cron), het backfill-script en de tests.
export * from './contract-mijlpalen'
// batch-67 portal-thema (FO-504) - de pure thema-engine van het portal-dashboard:
// NL-kalenderdag (Europe/Amsterdam), Gauss-Pasen met PublicHoliday-voorrang,
// Koningsdag-zondagsregel, periodes over de jaarwisseling, de prioriteit
// (verjaardag wint) en de wegklik-helpers (alleen localStorage, alleen die dag).
export * from './portal-thema'
// batch-67 hr-brieven (FO-506) - de pure regels van de HR-besluitworkflows:
// opzegtermijn (instelbare tabel, einde van de maand), aanzegging, bedenk- en
// bezwaartermijn, het stappenplan met blokkade, de statusmachine, de
// tag-controle die bij de HR-brieven blokkeert en de FIFO-afboeking van verlof.
export * from './hr-besluiten'
// batch-67 middelen-inname (FO-505 §A3) - het waardevoorstel voor een middel dat
// bij de inname ontbreekt of beschadigd is: basisprijs, lineaire afschrijving per
// categorie en het minimum restwaardepercentage. Puur; gedeeld door API en formulier.
export * from './inname-waarde'
export * from './middel-label'
// batch-67 middelen-inname (review B-I7) - bezwaartermijn in hele NL-dagen.
export * from './bezwaartermijn'
// batch-67 campagnes (FO-502 §2.5) - bezettingsconflicten per klant en ISO-week als
// pure functie (te veel monteurs van dezelfde klant tegelijk met vakantie).
export * from './campagne-bezettingsconflict'
// batch-68 controle (FO-342 §3.6) - het TVT-plafond per emmer (38/40 of parttime
// contracturen, x VerlofBeleid.tvt*MaxWeken). Alleen signaleren; afdwingen is een eigen FO.
export * from './tvt-plafond'
// batch-68 controle (FO-342 §5 / FO-343 §6) - urennotatie decimaal of u:mm (per gebruiker).
export * from './controle-notatie'
// batch-68 controle (FO-343 §4) - de afsprakenmotor: dagpijplijn, vaste prijs, reisbegrenzing, rekenspoor.
export * from './facturatie-regels'
// batch-68 werkplaatsfacturen (FO-341) - pure regels: voertuig-match op kenteken +
// chassisnummer, plausibiliteit, sectieclassificatie (trefwoord -> AI -> regels),
// interval per voertuig (override -> merk+model -> merk), badge-status, werkdagen
// en de documentnaam van de werkplaatsfactuur.
export * from './werkplaatsfacturen'
// batch-68 handtekening (FO-345 §3.4) - wie is er aan de beurt in de ondertekenaarslijst.
export * from './ondertekening-volgorde'
// batch-68 gespreksvoorbereiding (FO-346) - pure feitenberekeningen (periode,
// weekend/nacht, later begonnen/eerder gestopt, invuldeadline, verzuim-tellingen,
// korte-termijn-inzet, flexibiliteit, PBM-afwijking, weergave, medewerker-versie)
// en de kalenderdag-laag boven de gedeelde registratie-detectoren
// (`registratie-afwijkingen.ts`, een bron met FO-342 regel 1/3).
export * from './gespreksvoorbereiding'
export * from './gespreksvoorbereiding-afwijkingen'
// batch-68 integratie - de registratie-detectoren van FO-342 regel 1/3 en FO-346 §3.3/§3.4 op één plek.
export * from './registratie-afwijkingen'
// batch-68 atv-tvt-uitleg (FO-344) - ATV en TVT in gewone taal: de zinnen-matrix
// (tien geldige combinaties plus de legacy "TVT aan zonder ATV"), de
// rekenvoorbeelden via `tvtFactor`, het maximum per spaarpot, de vervaldatum, de
// VERLOFOPBOUW-payload van de keuzehulp en de handleiding-tokens.
export * from './werktijd-sparen-uitleg'
// FO-517 (spec 217) - beslisregels sollicitatiebeoordeling (scores, advies,
// consistentie, 2-van-3, 48-uursdeadline, salarisindicatie uit de functiematrix).
export * from './recruitment-beoordeling'
// PayrollCorrection - reis-origineel + reis-delta (één bron voor API-snapshot en
// formulier-voorvulling; voorkomt dubbel uitbetaalde dag-reis).
export * from './payroll-correctie-reis'
// batch-69 bestelflow (FO-512) - pure regels van de bestelflow-delta's: extern alleen
// voor het deel dat niet op voorraad ligt, de tijdelijke route "voorraadtelling in
// opbouw", het verplichte minimumniveau en de status-tijdlijn (portal + backoffice).
export * from './uitrusting-bestelflow'
// batch-69 km-balans (FO-515, spec 215) - pure rekenregels van de werk- en
// privekilometerbalans: standenfilter, meting op de maandgrenzen, factorkeuze
// (gemeten verbruik wint van elke ingestelde factor), schatting, verdeling over
// bestuurders, werkkilometers, balans en de vergelijking met de verklaring.
export * from './km-balans'
// batch-69 planbord-afspraak (FO-523, spec 223) - pure regels voor een afspraak met
// een klant: contactmoment-type en onderwerp, tijdvak naar UTC, de verslagmomenten
// (kwartier, 4 uur, volgende ochtend, 48 uur), de verslagstatus en de afscherm-
// beslisser `magContactMomentInhoudZien` (spiegel: `clientContactMomentWhere`).
export * from './planning-afspraak'
// batch-69 vakantiecampagne (FO-519) - de inrichting van Vakantie 2027, de status
// van een deelname uit de besluiten per periode, de snelkeuze "hele week" en de
// kleur van het saldo-effect. Puur; gedeeld door API, seed, portal en backoffice.
export * from './vakantiecampagne'
// batch-69 samenstellen (FO-509 / FO-510 / FO-516) - de pure regels van de
// samenstel-opdracht: regel- en opdrachtstatus, compleet-regel, voortgang,
// scanbeslissing, pakketdiff en het risico t.o.v. de startdatum.
export * from './samenstelling'
// batch-70 vakantiecampagne (FO-525 §C10-§C12) - opnamegraden, advies TVT/ATV en de
// doorrekening van het nieuwe jaar (puur; de zinnen staan in @streep/types).
export * from './vakantie-advies'
// batch-70 uitrusting-controle (FO-531) - de pure regels van de uitrustingscontrole:
// de afvinklijst uit wat de app weet, de compleet-regel voor de gereedschaps-
// overeenkomst, de mappings naar de koffer-statussen en de weergave per overeenkomst.
export * from './uitrustingscontrole'
// batch-70 voertuig-meldingen (FO-527) - de pure regels van de voertuigmutatie-
// meldingen: per kanaal melden of overslaan, NAW-relevantie, bundelen met de
// eindstand, onderwerpen en het herkennen van een antwoord, de bevestigingstermijn.
export * from './voertuig-meldingen'
// batch-70 wagenpark-week (FO-528 + FO-529) - weken, plausibiliteit, week-km, contract-trend,
// privé/zakelijk-verdeling, onderhoudsdatum, rit versus uren en de tankpas-regels.
export * from './wagenpark-week'
export * from './tankpas-week'
export * from './telematica-import'
// batch-70 app-dashboard (FO-526, spec 226) - CHANGELOG en specs lezen, "waar" bepalen
// en secties plus specs omzetten naar wijzigingen (sleutels, clusters per FO bij
// hergebruikte nummers, hernummering). Puur; gedeeld door api, script en drift-tests.
export * from './app-dashboard'
// batch-71 workflow-sjablonen (FO-533) - de pure regels van de stappenplannen: welke stap
// open mag (`bepaalStapStatussen`), voorwaarden op de bron (`evalueerVoorwaarde`) en de
// deadlines in Europe/Amsterdam (`volgendeDeadline`). `bepaalStapStatussen` en `StapStand`
// bestaan hier al voor de HR-besluiten: daarom een alias op deze rand.
export {
  bepaalStapStatussen as bepaalWorkflowStapStatussen,
  isStapKlaarStatus,
  runStatusUitStappen,
  stapVoortgang,
  vindAfhankelijkheidFout,
  zijnVerplichteStappenKlaar,
  type StapBesluit as WorkflowStapBesluit,
  type StapStand as WorkflowStapStand,
  type StapVoortgang as WorkflowStapVoortgang,
} from './workflow/stappen'
export * from './workflow/voorwaarde'
export * from './workflow/deadline'
// batch-71 gesprek-secties (FO-537) - de pure regels van de gesprekscontrole: afwijkingen,
// wat afronden tegenhoudt en de beoordeling van een onderhoudsmoment.
export * from './gesprek-controle'

// batch-71 kennismaking (FO-534, spec 234) - pure regels van de nalooplijst.
export * from './kennismaking'
// batch-71 profiel-in-beeld (FO-538) - regels, autofit en bijsnijding van de profielschets.
// Puur; gedeeld door de fill-engine, de schermweergave en de editor.
export * from './profiel-metrics'
export * from './profiel-fit'
